import { useState, useRef, useEffect } from "react";
import { getFontFamily } from "../constants/colors";

/*
 * OnboardingSlides — premium, full-screen, scene-style
 * Large SVG illustrations, CSS entrance animations, no white cards.
 */

// ── Large scene illustrations ──

const Scenes = {
  chapters: () => (
    <svg viewBox="0 0 320 240" fill="none" style={{ width: "100%", maxWidth: 340 }}>
      {/* Book stack */}
      <rect x="80" y="100" width="160" height="20" rx="4" fill="rgba(255,255,255,0.6)" />
      <rect x="85" y="80" width="150" height="20" rx="4" fill="rgba(255,255,255,0.55)" />
      <rect x="90" y="56" width="140" height="24" rx="5" fill="rgba(255,255,255,0.65)" />
      {/* Open book on top */}
      <path d="M120 56 L160 40 L200 56" stroke="rgba(255,255,255,0.9)" strokeWidth="2" fill="none" />
      <path d="M120 56 L120 20 Q140 10 160 20 L160 40" fill="rgba(255,255,255,0.65)" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" />
      <path d="M200 56 L200 20 Q180 10 160 20 L160 40" fill="rgba(255,255,255,0.65)" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" />
      {/* Page lines */}
      <line x1="130" y1="28" x2="155" y2="24" stroke="rgba(255,255,255,0.6)" strokeWidth="1" />
      <line x1="130" y1="35" x2="155" y2="30" stroke="rgba(255,255,255,0.6)" strokeWidth="1" />
      <line x1="130" y1="42" x2="155" y2="36" stroke="rgba(255,255,255,0.6)" strokeWidth="1" />
      <line x1="165" y1="24" x2="190" y2="28" stroke="rgba(255,255,255,0.6)" strokeWidth="1" />
      <line x1="165" y1="30" x2="190" y2="35" stroke="rgba(255,255,255,0.6)" strokeWidth="1" />
      {/* Floating concept bubbles */}
      <circle cx="60" cy="50" r="18" fill="rgba(255,255,255,0.6)" stroke="rgba(255,255,255,0.65)" strokeWidth="1" />
      <text x="60" y="55" textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="12" fontWeight="600">x²</text>
      <circle cx="260" cy="40" r="16" fill="rgba(255,255,255,0.6)" stroke="rgba(255,255,255,0.65)" strokeWidth="1" />
      <text x="260" y="44" textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="10" fontWeight="600">H₂O</text>
      <circle cx="250" cy="90" r="14" fill="rgba(255,255,255,0.22)" stroke="rgba(255,255,255,0.6)" strokeWidth="1" />
      <text x="250" y="94" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="9" fontWeight="600">F=ma</text>
      {/* Checkmark floating */}
      <circle cx="70" cy="100" r="12" fill="rgba(255,255,255,0.55)" />
      <path d="M64 100 L68 104 L76 96" stroke="rgba(255,255,255,0.8)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* Decorative dots */}
      <circle cx="40" cy="80" r="3" fill="rgba(255,255,255,0.65)" />
      <circle cx="280" cy="65" r="2" fill="rgba(255,255,255,0.65)" />
      <circle cx="100" cy="135" r="2" fill="rgba(255,255,255,0.22)" />
    </svg>
  ),

  stories: () => (
    <svg viewBox="0 0 320 240" fill="none" style={{ width: "100%", maxWidth: 340 }}>
      {/* Phone frame */}
      <rect x="110" y="20" width="100" height="160" rx="14" fill="rgba(255,255,255,0.22)" stroke="rgba(255,255,255,0.6)" strokeWidth="2" />
      <rect x="118" y="32" width="84" height="130" rx="4" fill="rgba(255,255,255,0.18)" />
      {/* Play button in center */}
      <circle cx="160" cy="90" r="20" fill="rgba(255,255,255,0.55)" stroke="rgba(255,255,255,0.65)" strokeWidth="1.5" />
      <polygon points="154,80 154,100 172,90" fill="rgba(255,255,255,0.8)" />
      {/* Story slides stacked behind */}
      <rect x="90" y="35" width="100" height="150" rx="12" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.65)" strokeWidth="1" />
      <rect x="130" y="25" width="100" height="150" rx="12" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.65)" strokeWidth="1" />
      {/* Timeline bar at bottom of phone */}
      <rect x="125" y="148" width="70" height="3" rx="1.5" fill="rgba(255,255,255,0.55)" />
      <rect x="125" y="148" width="30" height="3" rx="1.5" fill="rgba(255,255,255,0.6)" />
      {/* Floating history elements */}
      <rect x="40" y="55" width="48" height="36" rx="6" fill="rgba(255,255,255,0.22)" stroke="rgba(255,255,255,0.6)" strokeWidth="1" />
      <line x1="48" y1="66" x2="80" y2="66" stroke="rgba(255,255,255,0.65)" strokeWidth="1" />
      <line x1="48" y1="73" x2="72" y2="73" stroke="rgba(255,255,255,0.55)" strokeWidth="1" />
      <line x1="48" y1="80" x2="76" y2="80" stroke="rgba(255,255,255,0.55)" strokeWidth="1" />
      <rect x="232" y="65" width="48" height="36" rx="6" fill="rgba(255,255,255,0.22)" stroke="rgba(255,255,255,0.6)" strokeWidth="1" />
      <line x1="240" y1="76" x2="272" y2="76" stroke="rgba(255,255,255,0.65)" strokeWidth="1" />
      <line x1="240" y1="83" x2="264" y2="83" stroke="rgba(255,255,255,0.55)" strokeWidth="1" />
      {/* Swipe arrows */}
      <path d="M220 90 L235 90" stroke="rgba(255,255,255,0.65)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M232 86 L236 90 L232 94" stroke="rgba(255,255,255,0.65)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),

  ai: () => (
    <svg viewBox="0 0 320 240" fill="none" style={{ width: "100%", maxWidth: 340 }}>
      {/* Chat bubbles */}
      <rect x="60" y="30" width="130" height="40" rx="12" fill="rgba(255,255,255,0.55)" />
      <path d="M80 70 L72 82 L92 70" fill="rgba(255,255,255,0.55)" />
      <line x1="75" y1="44" x2="170" y2="44" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="75" y1="54" x2="150" y2="54" stroke="rgba(255,255,255,0.65)" strokeWidth="1.5" strokeLinecap="round" />
      {/* AI response bubble */}
      <rect x="130" y="90" width="150" height="56" rx="12" fill="rgba(255,255,255,0.65)" stroke="rgba(255,255,255,0.55)" strokeWidth="1.5" />
      <path d="M250 146 L258 158 L238 146" fill="rgba(255,255,255,0.65)" stroke="rgba(255,255,255,0.55)" strokeWidth="1" />
      {/* Step indicators in AI bubble */}
      <circle cx="148" cy="108" r="8" fill="rgba(255,255,255,0.65)" />
      <text x="148" y="112" textAnchor="middle" fill="rgba(255,255,255,0.9)" fontSize="10" fontWeight="700">1</text>
      <line x1="162" y1="108" x2="260" y2="108" stroke="rgba(255,255,255,0.65)" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="148" cy="126" r="8" fill="rgba(255,255,255,0.65)" />
      <text x="148" y="130" textAnchor="middle" fill="rgba(255,255,255,0.9)" fontSize="10" fontWeight="700">2</text>
      <line x1="162" y1="126" x2="245" y2="126" stroke="rgba(255,255,255,0.65)" strokeWidth="1.5" strokeLinecap="round" />
      {/* Lightbulb */}
      <circle cx="52" cy="120" r="16" fill="rgba(255,255,255,0.22)" stroke="rgba(255,255,255,0.65)" strokeWidth="1.5" />
      <path d="M46 115 Q52 105 58 115 L56 125 L48 125 Z" fill="rgba(255,255,255,0.6)" />
      <line x1="49" y1="129" x2="55" y2="129" stroke="rgba(255,255,255,0.6)" strokeWidth="1" strokeLinecap="round" />
      <line x1="50" y1="132" x2="54" y2="132" stroke="rgba(255,255,255,0.6)" strokeWidth="1" strokeLinecap="round" />
      {/* Floating math */}
      <text x="100" y="170" fill="rgba(255,255,255,0.55)" fontSize="14" fontWeight="600">x = ?</text>
      <path d="M165 168 L175 178" stroke="rgba(255,255,255,0.55)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M175 168 L165 178" stroke="rgba(255,255,255,0.55)" strokeWidth="1.5" strokeLinecap="round" />
      <text x="190" y="178" fill="rgba(255,255,255,0.65)" fontSize="14" fontWeight="600">x = 5</text>
      <path d="M178 173 L186 173" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M183 170 L186 173 L183 176" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),

  tests: () => (
    <svg viewBox="0 0 320 240" fill="none" style={{ width: "100%", maxWidth: 340 }}>
      {/* Test paper */}
      <rect x="90" y="20" width="140" height="170" rx="8" fill="rgba(255,255,255,0.6)" stroke="rgba(255,255,255,0.55)" strokeWidth="1.5" />
      {/* Header line */}
      <rect x="110" y="34" width="100" height="4" rx="2" fill="rgba(255,255,255,0.65)" />
      {/* Question lines with circles */}
      {[58, 82, 106, 130].map((y, i) => (
        <g key={i}>
          <circle cx="115" cy={y + 6} r="7" fill={i < 2 ? "rgba(255,255,255,0.65)" : "rgba(255,255,255,0.22)"} stroke="rgba(255,255,255,0.65)" strokeWidth="1" />
          {i < 2 && <path d={`M112 ${y+6} L114 ${y+8} L119 ${y+3}`} stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />}
          <line x1="130" y1={y + 6} x2="210" y2={y + 6} stroke="rgba(255,255,255,0.55)" strokeWidth="1.5" strokeLinecap="round" />
        </g>
      ))}
      {/* Score circle */}
      <circle cx="250" cy="55" r="28" fill="rgba(255,255,255,0.6)" stroke="rgba(255,255,255,0.6)" strokeWidth="2" />
      <text x="250" y="52" textAnchor="middle" fill="rgba(255,255,255,0.9)" fontSize="16" fontWeight="800">8</text>
      <line x1="238" y1="58" x2="262" y2="58" stroke="rgba(255,255,255,0.6)" strokeWidth="1" />
      <text x="250" y="70" textAnchor="middle" fill="rgba(255,255,255,0.65)" fontSize="10">10</text>
      {/* Flash cards fanned */}
      <rect x="40" y="100" width="56" height="72" rx="8" fill="rgba(255,255,255,0.18)" stroke="rgba(255,255,255,0.55)" strokeWidth="1" transform="rotate(-8 68 136)" />
      <rect x="44" y="96" width="56" height="72" rx="8" fill="rgba(255,255,255,0.6)" stroke="rgba(255,255,255,0.6)" strokeWidth="1" transform="rotate(-4 72 132)" />
      <rect x="48" y="92" width="56" height="72" rx="8" fill="rgba(255,255,255,0.18)" stroke="rgba(255,255,255,0.55)" strokeWidth="1" />
      <text x="76" y="122" textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="10" fontWeight="600">Q</text>
      <line x1="58" y1="132" x2="94" y2="132" stroke="rgba(255,255,255,0.65)" strokeWidth="1" strokeLinecap="round" />
      <line x1="62" y1="140" x2="90" y2="140" stroke="rgba(255,255,255,0.55)" strokeWidth="1" strokeLinecap="round" />
      {/* Progress bar */}
      <rect x="245" y="110" width="8" height="70" rx="4" fill="rgba(255,255,255,0.22)" />
      <rect x="245" y="140" width="8" height="40" rx="4" fill="rgba(255,255,255,0.6)" />
    </svg>
  ),
};

const SLIDES = [
  {
    scene: "chapters",
    bg: "linear-gradient(165deg, #1A6B8A 0%, #2A8AAA 35%, #4AACCC 100%)",
    en: { title: "Learn one concept\nat a time", sub: "Interactive slides for Maths, Science, History and more — with instant checks after every idea" },
    hi: { title: "एक-एक concept\nसीखो", sub: "Maths, Science, History और ज़्यादा — हर idea के बाद तुरंत check के साथ interactive slides" },
  },
  {
    scene: "stories",
    bg: "linear-gradient(165deg, #8A6A2A 0%, #AA8A3A 35%, #CCAA5A 100%)",
    en: { title: "Stories that stick,\nnot bore", sub: "History, Civics, Economics — short visual stories that make chapters unforgettable" },
    hi: { title: "Stories जो याद रहें,\nbore नहीं करें", sub: "History, Civics, Economics — छोटी visual stories जो chapters को unforgettable बनाएं" },
  },
  {
    scene: "ai",
    bg: "linear-gradient(165deg, #0A5A3A 0%, #1A7A52 35%, #2A9A6A 100%)",
    en: { title: "AI that teaches\nnot just answers", sub: "Stuck on homework? Step-by-step guidance that helps you think — not copy" },
    hi: { title: "AI जो सिखाए\nसिर्फ जवाब नहीं दे", sub: "Homework में stuck? Step-by-step guide करे — copy नहीं करवाए" },
  },
  {
    scene: "tests",
    bg: "linear-gradient(165deg, #3A2A6A 0%, #5A4A8A 35%, #7A6AAA 100%)",
    en: { title: "Test yourself\nrevise smarter", sub: "Board-style tests and flash cards — everything for exam prep in one place" },
    hi: { title: "खुद को परखो\nsmartly revise करो", sub: "Board-style tests और flash cards — exam prep का सब कुछ एक जगह" },
  },
];

// CSS keyframes injected once
const ANIM_STYLE = `
@keyframes onb-fadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: translateY(0); } }
@keyframes onb-scaleIn { from { opacity: 0; transform: scale(0.85); } to { opacity: 1; transform: scale(1); } }
@keyframes onb-float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-8px); } }
`;

export function OnboardingSlides({ onDone, lang = "en", setLang }) {
  const ff = getFontFamily(lang);
  const isHi = lang === "hi";
  const [current, setCurrent] = useState(0);
  const [animKey, setAnimKey] = useState(0);
  const touchStartX = useRef(0);
  const touchDeltaX = useRef(0);

  const slide = SLIDES[current];
  const msg = isHi ? slide.hi : slide.en;
  const isLast = current === SLIDES.length - 1;

  const goTo = (idx) => { setCurrent(idx); setAnimKey(k => k + 1); };
  const goNext = () => { if (isLast) { markDone(); onDone?.(); } else goTo(current + 1); };
  const goPrev = () => { if (current > 0) goTo(current - 1); };
  const markDone = () => { try { localStorage.setItem("samajh-onboarding-done", "true"); } catch {} };
  const handleSkip = () => { markDone(); onDone?.(); };

  const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; touchDeltaX.current = 0; };
  const onTouchMove = (e) => { touchDeltaX.current = e.touches[0].clientX - touchStartX.current; };
  const onTouchEnd = () => {
    if (touchDeltaX.current < -50) goNext();
    else if (touchDeltaX.current > 50) goPrev();
    touchDeltaX.current = 0;
  };

  return (
    <div
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      style={{
        height: "100dvh", display: "flex", flexDirection: "column",
        background: slide.bg, fontFamily: ff, overflow: "hidden",
        transition: "background 0.6s ease",
      }}
    >
      <style>{ANIM_STYLE}</style>

      {/* Top bar */}
      <div style={{ padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexShrink: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{
            width: 30, height: 30, background: "rgba(255,255,255,0.65)", borderRadius: 8,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontFamily: "Georgia,serif", fontSize: 16, fontWeight: 600, color: "rgba(255,255,255,0.8)",
          }}>S.</div>
          <span style={{ fontSize: 13, fontWeight: 700, color: "rgba(255,255,255,0.65)", letterSpacing: "0.04em" }}>SAMAJH</span>
        </div>
        {/* Language toggle */}
        {setLang && (
          <div style={{ display: "flex", background: "rgba(255,255,255,0.12)", borderRadius: 8, padding: 2 }}>
            <div onClick={() => setLang("en")} style={{
              padding: "4px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700,
              cursor: "pointer", transition: "all 0.2s",
              background: !isHi ? "rgba(255,255,255,0.9)" : "transparent",
              color: !isHi ? "#0A1820" : "rgba(255,255,255,0.6)",
            }}>EN</div>
            <div onClick={() => setLang("hi")} style={{
              padding: "4px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700,
              cursor: "pointer", transition: "all 0.2s",
              background: isHi ? "rgba(255,255,255,0.9)" : "transparent",
              color: isHi ? "#0A1820" : "rgba(255,255,255,0.6)",
            }}>हिं</div>
          </div>
        )}
        {!isLast ? (
          <div onClick={handleSkip} style={{
            fontSize: 13, color: "rgba(255,255,255,0.6)", fontWeight: 600, cursor: "pointer",
            padding: "5px 14px", borderRadius: 10,
            background: "rgba(255,255,255,0.22)",
          }}>
            {isHi ? "छोड़ें" : "Skip"}
          </div>
        ) : (
          <div style={{ padding: "5px 14px", fontSize: 13, visibility: "hidden" }}>Skip</div>
        )}
      </div>

      {/* Illustration — large, fills upper area */}
      <div key={`scene-${animKey}`} style={{
        flex: "0 0 auto", padding: "0 10px",
        display: "flex", justifyContent: "center", alignItems: "center",
        minHeight: 220,
        animation: "onb-scaleIn 0.5s ease both, onb-float 4s ease-in-out infinite",
        filter: "drop-shadow(0 8px 24px rgba(0,0,0,0.12))",
      }}>
        {Scenes[slide.scene]()}
      </div>

      {/* Text content — tight below illustration */}
      <div key={`text-${animKey}`} style={{
        flex: 1, padding: "12px 28px 0",
        display: "flex", flexDirection: "column",
        animation: "onb-fadeUp 0.5s ease 0.15s both",
      }}>
        {/* Title — large, multiline */}
        <div style={{
          fontSize: 28, fontWeight: 800, color: "white",
          letterSpacing: "-0.03em", lineHeight: 1.2,
          whiteSpace: "pre-line",
        }}>
          {msg.title}
        </div>

        {/* Subtitle */}
        <div style={{
          fontSize: 14, color: "rgba(255,255,255,0.88)",
          lineHeight: 1.7, fontWeight: 500, marginTop: 12,
          maxWidth: 340,
        }}>
          {msg.sub}
        </div>
      </div>

      {/* Bottom — counter + dots + button */}
      <div style={{ padding: "0 24px 32px", flexShrink: 0 }}>
        {/* Step counter */}
        <div style={{ textAlign: "center", marginBottom: 10, fontSize: 11, fontWeight: 600, color: "rgba(255,255,255,0.5)" }}>
          {current + 1} / {SLIDES.length}
        </div>
        {/* Dots */}
        <div style={{ display: "flex", justifyContent: "center", gap: 8, marginBottom: 18 }}>
          {SLIDES.map((_, i) => (
            <div key={i} onClick={() => goTo(i)} style={{
              width: i === current ? 24 : 10, height: 10, borderRadius: 5,
              background: i === current ? "white" : "rgba(255,255,255,0.35)",
              transition: "all 0.3s", cursor: "pointer",
              boxShadow: i === current ? "0 2px 8px rgba(255,255,255,0.3)" : "none",
            }} />
          ))}
        </div>

        {/* CTA */}
        <div onClick={goNext} style={{
          width: "100%", padding: "16px", borderRadius: 16,
          background: "white", color: "#0A1820",
          fontSize: 16, fontWeight: 800, textAlign: "center",
          cursor: "pointer", letterSpacing: "-0.02em",
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
        }}>
          {isLast ? (isHi ? "शुरू करें →" : "Get started →") : (isHi ? "आगे →" : "Next →")}
        </div>

        {/* Class info */}
        <div style={{ textAlign: "center", marginTop: 10, fontSize: 10, color: "rgba(255,255,255,0.6)", fontWeight: 600, letterSpacing: "0.05em" }}>
          CLASS 10 · CBSE · HINDI & ENGLISH
        </div>
      </div>
    </div>
  );
}

export function shouldShowOnboarding() {
  // Always show onboarding — skip button lets users dismiss
  return true;
}
